import { ACTION_TYPES } from "../../../constants/index";
import Cookies from "js-cookie";

export const setAuth = (payload) => {
  // console.log("Auth action dispatched, token exists:", tokenExists);
  return {
    type: ACTION_TYPES.AUTH,
    payload: payload,
  };
};